export class Program implements _Program {
  constructor(
    public id: string,
    public title: string,
    public description: string | null,
    public movie: string | null,
    public channel: 'tch1' | 'tch2',
    public thumbnailUrl: string | null,
    public page: string | null,
    public start: string | null,
    public end: string | null,
    public episode: string | null,
    public eptitle: string | null,
    public onairPlan: string | null,
    public genres: string[] | null,
    public epdescription: string | null,
    public epthumbnailUrl: string | null
  ) {}

  public clone = (program: Program) => {
    return new Program(
      program.id,
      program.title,
      program.description,
      program.movie,
      program.channel,
      program.thumbnailUrl,
      program.page,
      program.start,
      program.end,
      program.episode,
      program.eptitle,
      program.onairPlan,
      program.genres,
      program.epdescription,
      program.epthumbnailUrl
    );
  };
}

export interface _Program {
  id: string;
  title: string;
  description: string | null;
  movie: string | null;
  channel: 'tch1' | 'tch2';
  thumbnailUrl: string | null;
  page: string | null;
  start: string | null;
  end: string | null;
  episode: string | null;
  eptitle: string | null;
  onairPlan: string | null;
  genres: string[] | null;
  epdescription: string | null;
  epthumbnailUrl: string | null;
}

export class ProgramBuilder {
  private _id: Program['id'] = '';
  private _title: Program['title'] = '';
  private _description: Program['description'] = null;
  private _movie: Program['movie'] = null;
  private _channel: Program['channel'] = 'tch1';
  private _thumbnailUrl: Program['thumbnailUrl'] = null;
  private _page: Program['page'] = null;
  private _start: Program['start'] = null;
  private _end: Program['end'] = null;
  private _episode: Program['episode'] = null;
  private _eptitle: Program['eptitle'] = null;
  private _onairPlan: Program['onairPlan'] = null;
  private _genres: Program['genres'] = [];
  private _epdescription: Program['epdescription'] = null;
  private _epthumbnailUrl: Program['epthumbnailUrl'] = null;

  withId(id: Program['id']): ProgramBuilder {
    this._id = id;
    return this;
  }

  withTitle(title: Program['title']): ProgramBuilder {
    this._title = title;
    return this;
  }

  withEptitle(eptitle: Program['eptitle']): ProgramBuilder {
    this._eptitle = eptitle;
    return this;
  }

  withEpisode(episode: Program['episode']): ProgramBuilder {
    this._episode = episode;
    return this;
  }

  withStart(start: Program['start']): ProgramBuilder {
    this._start = start;
    return this;
  }

  withEnd(end: Program['end']): ProgramBuilder {
    this._end = end;
    return this;
  }

  withChannel(channel: Program['channel']): ProgramBuilder {
    this._channel = channel;
    return this;
  }

  withOnairPlan(onairPlan: Program['onairPlan']): ProgramBuilder {
    this._onairPlan = onairPlan;
    return this;
  }

  withThumbnailUrl(thumbnailUrl: Program['thumbnailUrl']) {
    this._thumbnailUrl = thumbnailUrl;
    return this;
  }

  withPage(page: Program['page']) {
    this._page = page;
    return this;
  }

  withDescription(description: Program['description']): ProgramBuilder {
    this._description = description;
    return this;
  }

  withEpDescription(epdescription: Program['epdescription']): ProgramBuilder {
    this._epdescription = epdescription;
    return this;
  }

  withEpThumbnailUrl(epthumbnailUrl: Program['epthumbnailUrl']): ProgramBuilder {
    this._epthumbnailUrl = epthumbnailUrl;
    return this;
  }

  build(): Program {
    return new Program(
      this._id,
      this._title,
      this._description,
      this._movie,
      this._channel,
      this._thumbnailUrl,
      this._page,
      this._start,
      this._end,
      this._episode,
      this._eptitle,
      this._onairPlan,
      this._genres,
      this._epdescription,
      this._epthumbnailUrl
    );
  }

  objectBuild(): _Program {
    return {
      id: this._id,
      title: this._title,
      description: this._description,
      movie: this._movie,
      channel: this._channel,
      thumbnailUrl: this._thumbnailUrl,
      page: this._page,
      start: this._start,
      end: this._end,
      episode: this._episode,
      eptitle: this._eptitle,
      onairPlan: this._onairPlan,
      genres: this._genres,
      epdescription: this._epdescription,
      epthumbnailUrl: this._epthumbnailUrl,
    };
  }
}
